import React from 'react';
import { renderInputsForAurora } from './renderInputs';
import { products } from '__common/constants/products';
import { state } from '__common/store';
import { metersToInches } from '__common/calculations/metersToInches';
import { Divider } from '@mui/material';

export const osPage = (
  currentConfig: Function,
  productId: string,
  initData: projectEnvConfig,
  mapType: string,
  location: string,
  onChange: Function,
  getErrorMessageIfInvalid: (fieldName: string) => string | null,
) => {
  const buildingCode = initData['building_code'];
  const config = currentConfig(buildingCode);
  


  return {
    content: (
      <>
        <div className="drawer-section-title">Open Solar Configuration</div>
                            <Divider sx={{  
            mt: "-5px",
            mb: "12px", 
            borderColor: "#663a3a",
          }} />
        {osImportWarnings(initData, productId)}
        <div className="input-soft-warning">
          Before importing the project check parameters below:
        </div>
        <div className="drawer-fields helioscope-drawer-field">
          <div>{renderInputsForAurora(config.Os, mapType, location, initData, products[productId], onChange, getErrorMessageIfInvalid)}</div>
        </div>
      </>
    ),
    tooltip: 'Open Solar Configuration',
  };
};

const osImportWarnings = (initData, productId: string) => {
  const { settings, projectConfiguration : { projectEnvConfig } } = state();
  return (
    <>
      {
        projectEnvConfig?.messages && projectEnvConfig.messages.length > 0 && projectEnvConfig.messages.map((value, index)=> <div className="input-warning" key={index}>{value}</div>)
      }
      { settings?.rowSpacing && 
      (<div className="input-soft-warning">
        Project row spacing will be updated to {metersToInches(settings?.rowSpacing).toFixed(2)} inches.
      </div>)}
      { settings?.columnSpacing && 
      (<div className="input-soft-warning">
        Project column spacing will be updated to {metersToInches(settings?.columnSpacing).toFixed(2)} inches.
      </div>)}
    </>
  );
}

